module.exports = __webpack_public_path__ + "img/wordmark-light.26cbf8dc.svg";